import { render, staticRenderFns } from "./Service2Table.vue?vue&type=template&id=77cab5cf&"
import script from "./Service2Table.vue?vue&type=script&lang=js&"
export * from "./Service2Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports